import { useMemo } from 'react'

export enum SiteSurveyStatuses {
    LOADING = 'loading',
    PENDING = 'pending',
    IN_PROGRESS = 'in progress',
    SUCCESS = 'success',
    FAILED = 'failed',
    EXCEPTION = 'exception',
    UNKNOWN = 'unknown',
    ERROR = 'error'
}

export type SiteSurveyStatusResult = {
    status: SiteSurveyStatuses
    isSiteSurveyLoading: boolean
    isSiteSurveySuccess: boolean
    isSiteSurveyFailed: boolean
    isSiteSurveyException: boolean
}

const normaliseStatus = (rawStatus?: Nullable<string>): SiteSurveyStatuses => {
    if (!rawStatus) return SiteSurveyStatuses.UNKNOWN

    const value: string = rawStatus.toLowerCase()

    if (value.includes(SiteSurveyStatuses.SUCCESS)) return SiteSurveyStatuses.SUCCESS
    if (value.includes(SiteSurveyStatuses.FAILED)) return SiteSurveyStatuses.FAILED
    if (value.includes(SiteSurveyStatuses.PENDING)) return SiteSurveyStatuses.LOADING
    if (value.includes(SiteSurveyStatuses.IN_PROGRESS)) return SiteSurveyStatuses.LOADING
    if (value.includes(SiteSurveyStatuses.EXCEPTION) || value.includes(SiteSurveyStatuses.ERROR)) {
        return SiteSurveyStatuses.EXCEPTION
    }

    return SiteSurveyStatuses.UNKNOWN
}

export function useSiteSurveyStatus(rawStatus?: Nullable<string>): SiteSurveyStatusResult {
    return useMemo(() => {
        const status: SiteSurveyStatuses = normaliseStatus(rawStatus)

        return {
            status,
            isSiteSurveyLoading: status === SiteSurveyStatuses.LOADING,
            isSiteSurveySuccess: status === SiteSurveyStatuses.SUCCESS,
            isSiteSurveyFailed: status === SiteSurveyStatuses.FAILED,
            isSiteSurveyException: status === SiteSurveyStatuses.EXCEPTION
        }
    }, [rawStatus])
}
